import { useContext } from 'react';
import { DataInputIconsContext } from '@/context/DataInputIconContext/context.tsx';

export function useDataInputIconContext() {
  const ctx = useContext(DataInputIconsContext);
  if (!ctx) throw new Error('useDataInputIconContext must be used within DataInputIconsProvider');
  return ctx;
}
